export const GET_STATIC_PAGE = 'GET_STATIC_PAGE'
export const GET_INVITE_DATA = 'GET_INVITE_DATA'
export const GET_DECRYPT_DATA = 'GET_DECRYPT_DATA'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const GET_COMPANY_OWNER_DATA = 'GET_COMPANY_OWNER_DATA'
export const GET_SKYFLOW_CARDS = 'GET_SKYFLOW_CARDS'
